import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";

/**
 * Whether the user may assign project members a role other than viewer in the selected project.
 *
 * The workspace context only reports the feature as permitted for users with a workspace level
 * role, e.g. enterprise admins. A project admin without one gets it permitted only in the
 * project's own features, so both levels are checked.
 */
export function useCanAssignProjectRoles() {
  const {
    canAssignProjectRoles: canAssignInWorkspace
  } = useHasUserValidFeatureCompanyLevel();
  const {
    canAssignProjectRoles: canAssignInProject
  } = useHasValidFeatureProjectLevel();
  return canAssignInWorkspace || canAssignInProject;
}